import { EditOutlined } from "@ant-design/icons";
import { Button, Drawer, Form, Input } from "antd";
import { useForm } from "antd/es/form/Form";
import axios from "axios";
import { useEffect, useState } from "react";

const EditAttributeDrawer = ({ token, record }) => {
  const [form] = useForm();
  const [visible, setVisible] = useState(false);

  const createNewTypeAttribute = (values) => {
    axios
      .post(
        `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/attributes?token=${token}`,
        values
      )
      .then(() => {
        setVisible(false);
        form.resetFields();
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    if (visible && record) {
      axios
        .get(
          `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/attributes/${record.value}?token=${token}`
        )
        .then((res) => {
          form.setFieldsValue(res.data);
        });
    }
  }, [visible, record, token, form]);

  return (
    <>
      {" "}
      <Button
        icon={<EditOutlined />}
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setVisible(true);
          console.log(record);
        }}
      />
      <Drawer
        open={visible}
        placement="right"
        onClose={() => setVisible(false)}
        title="Редактирование атрибута"
      >
        <Form form={form} layout="vertical" onFinish={createNewTypeAttribute}>
          <Form.Item label="Название" name="name">
            <Input />
          </Form.Item>
          <Form.Item label="*alias" name="alias">
            <Input />
          </Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
            Создать
          </Button>
        </Form>
      </Drawer>
    </>
  );
};

export default EditAttributeDrawer;
